"use client";
import { useEffect } from "react";

import { getCookieByName } from "@stadium/helpers/src/cookie";
import { HUBSPOT_UTK_COOKIE_NAME } from "@stadium/services/hubspot/constants";

const BodyEventListener = () => {
  useEffect(() => {
    const handleCrossDomainClick = (e) => {
      let linkElement = e.target;
      if (!linkElement || !("tagName" in linkElement)) return;

      if (linkElement.tagName !== "A") {
        linkElement = linkElement.closest("a");
      }

      if (!linkElement?.href || linkElement?.target === "_self") return;
      if (linkElement?.getAttribute("data-skip-cross-domain-cookie-transfer") === "true") return;

      const url = new URL(linkElement.href, window.location.origin);

      if (url.protocol === "blob:" || url.protocol === "data:") return;

      if (url.hostname.includes(window.location.hostname)) return;

      const cookiesToTransfer = [HUBSPOT_UTK_COOKIE_NAME, "__hstc", "__hsfp", "__hssc"];
      cookiesToTransfer.forEach((cookieName) => {
        const cookieValue = getCookieByName(cookieName);
        if (!cookieValue || url.searchParams.has(cookieName)) return;
        url.searchParams.set(cookieName, cookieValue);
      });

      linkElement.setAttribute("href", url.toString());
    };

    document.body.addEventListener("click", handleCrossDomainClick, true);

    return () => {
      document.body.removeEventListener("click", handleCrossDomainClick, true);
    };
  }, []);

  return null;
};

export default BodyEventListener;
